import actions from "./actions";

const initState = {
  books: null,
  book: {},
  bonusContents: null,
  bonusBook: null,
  roles: null,
  subjects: null,
  schools: null,
  grades: null,
  users: null,
  key: null,
  tests: [],
  units: [],
  loading: false,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_BOOKS_SUCCESS:
      return { ...state, books: action.books };

    case actions.FETCH_BOOK_DETAILS_SUCCESS:
      return { ...state, book: action.book };

    case actions.FETCH_BONUS_BOOKS_SUCCESS:
      return { ...state, bonusContents: action.bonusContents };

    case actions.FETCH_BONUS_BOOK_DETAILS_SUCCESS:
      return { ...state, bonusBook: action.bonusBook };

    case actions.FETCH_BOOK_CONFIGS_SUCCESS:
      return { ...state, schools: action.schools };

    case actions.FETCH_BONUS_CONTENT_USERS_SUCCESS:
      return { ...state, users: action.users };

    case actions.SET_FILTER:
      return { ...state, key: action.key };

    case actions.RESET:
      return {
        ...state,
        books: null,
        book: null,
        bonusContents: null,
        bonusBook: null,
      };

    case actions.FETCH_SCHOOLS_SUCCESS:
      return { ...state, schools: action.schools, loading: false };

    case actions.FETCH_LESSON_TESTS_SUCCESS:
      return { ...state, tests: action.tests };

    case actions.FETCH_COURSE_LESSON_SUCCESS:
      return { ...state, units: action.units };

    default:
      return state;
  }
}
